import { render } from "./EliminaDestino.vue?vue&type=template&id=1f489588&scoped=true"
import script from "./EliminaDestino.vue?vue&type=script&lang=js"
export * from "./EliminaDestino.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./EliminaDestino.vue?vue&type=style&index=1&id=1f489588&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f489588"]])

export default __exports__